import {memo, ReactElement} from 'react';
import FeaturedProjectCard from './FeaturedProjectCard';
import {FeaturedProject} from 'types';

type FeaturedProjectsSectionProps = {
  title: string;
  subtitle: string;
  projects: FeaturedProject[];
};

function FeaturedProjectsGrid({title, subtitle, projects}: FeaturedProjectsSectionProps): ReactElement {
  return (
    <div className="projects-section-root">
      <div className="section-head">
        <h2 className="section-title">{title}</h2>
        <p className="section-subtitle">{subtitle}</p>
      </div>
      <div className="section-content-shell">
        <div className="section-content">
          <div className="section-repos">
            {projects.map((project) => <FeaturedProjectCard key={project.id} project={project} />)}
          </div>
        </div>
      </div>
    </div>
  );
}

export const FeaturedProjectsSection = memo(FeaturedProjectsGrid);
